import React from 'react';
import { Card } from '../../components/common/Card';

export const Analytics: React.FC = () => {
  return (
    <Card title="Analytics">
      <p className="text-gray-600">Analytics dashboard coming soon.</p>
    </Card>
  );
};